import EventEmitter from "./EventEmitter";

type EventTypes = "tick";

export default class Time extends EventEmitter<EventTypes> {
    readonly #start: number;

    #currentTime: number = 0;
    #elapsedTime: number = 0;
    #deltaTime: number = 16;
    #rafId: number = 0;

    constructor() {
        super();

        this.#start = Date.now();
        this.#rafId = window.requestAnimationFrame(this.#tick);
    }

    get start(): number {
        return this.#start;
    }
    get currentTime(): number {
        return this.#currentTime;
    }
    get elapsedTime(): number {
        return this.#elapsedTime;
    }
    get deltaTime(): number {
        return this.#deltaTime;
    }

    #calculateTimes = (): void => {
        const now = Date.now();
        this.#deltaTime = now - this.#currentTime;
        this.#currentTime = now;
        this.#elapsedTime = now - this.#start;
    };

    #tick = (): void => {
        this.#calculateTimes();
        this.trigger("tick");
        this.#rafId = window.requestAnimationFrame(this.#tick);
    };

    destroy = (): void => {
        cancelAnimationFrame(this.#rafId);
    };
}
